import { FormattedMessage } from 'react-intl'

import { Typography } from '@gto/ui/typography'

export const PromoPageHeader = () => {
  return (
    <section className="flex flex-col gap-8 text-center sm:gap-4">
      <Typography
        color="primary"
        component="h1"
        variant="h3"
      >
        <FormattedMessage id="promo.page.title" />
      </Typography>

      <Typography
        color="text.primary"
        component="h2"
        variant="h5"
      >
        <FormattedMessage
          id="promo.page.description"
          values={{
            prize: '$40,000',

            highlight: (chunks) => (
              <Typography
                className="[font-size:inherit] [font-weight:inherit] [line-height:inherit]"
                color="primary"
                component="span"
              >
                {chunks}
              </Typography>
            ),
          }}
        />
      </Typography>
    </section>
  )
}
